module.exports = {"533301001":"大练地街道","533301002":"六库街道","533301102":"鲁掌镇","533301103":"片马镇","533301104":"上江镇","533301105":"老窝镇","533301106":"大兴地镇","533301204":"称杆乡","533301205":"古登乡","533301206":"洛本卓白族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/533301.json
// module id = 2801
// module chunks = 0